import { render, staticRenderFns } from "./shoppingPlatformCategory.vue?vue&type=template&id=d755867a&"
import script from "./shoppingPlatformCategory.vue?vue&type=script&lang=js&"
export * from "./shoppingPlatformCategory.vue?vue&type=script&lang=js&"
import style0 from "./shoppingPlatformCategory.vue?vue&type=style&index=0&id=d755867a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports